import React from 'react';
import { Typography,ListItemText } from '@material-ui/core';

export default function ComplexDescription(props) {
    const { element, SecondaryDescription } = props;

    const PrimaryDescription= (element)=>{
        return (
            <React.Fragment>
                <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                    style={element.titleStyle?element.titleStyle:null}
                >
                    {element.title?element.title:""}
                </Typography>
            </React.Fragment>
        )
    }


    return (
        <React.Fragment>
            <ListItemText 
                primary={<PrimaryDescription {...element}/>}
                secondary={SecondaryDescription?<SecondaryDescription {...element}/>: element.description}
            />
        </React.Fragment>
        
    )

}
